import * as React from 'react';
import * as _ from 'lodash';
import * as stageActions from '../stage/stage';
import * as desktopElementActions from '../element/actions/desktopElementActions';
import {BasicDialogProps} from 'cl-dialogs/BasicDialog';
import {PopoverProps} from '@material-ui/core/Popover';
import {Map} from 'immutable';
const OPEN_LAZY_PANEL = 'crazyEditor/panel/OPEN_LAZY_PANEL';
const SHOW_LAZY_PANEL = 'crazyEditor/panel/SHOW_LAZY_PANEL';
const CLOSE_LAZY_PANEL = 'crazyEditor/panel/CLOSE_LAZY_PANEL';
const UPDATE_LAZY_PANEL_PROPS = 'crazyEditor/panel/UPDATE_LAZY_PANEL_PROPS';

const OPEN_STATIC_PANEL = 'crazyEditor/panel/OPEN_STATIC_PANEL';
const CLOSE_STATIC_PANEL = 'crazyEditor/panel/CLOSE_STATIC_PANEL';
const ADD_DYNAMIC_ELEMENT = 'crazyEditor/panel/ADD_DYNAMIC_ELEMENT';
const CLOSE_DYNAMIC_ELEMENT = 'crazyEditor/panel/CLOSE_DYNAMIC_ELEMENT';
const REMOVE_DYNAMIC_ELEMENT = 'crazyEditor/panel/REMOVE_DYNAMIC_ELEMENT';

const TOGGLE_LEFT_MENU_SELECTED_ITEM = 'crazyEditor/panel/TOGGLE_LEFT_MENU_SELECTED_ITEM';

import update from 'immutability-helper';
import {makeActionCreator} from '../../helpers';

export default function reducer(state: any = {}, action: any = {}) {
  let panelIndex;
  switch (action.type) {
    case OPEN_LAZY_PANEL:
      panelIndex = _.findIndex(state.openedLazyPanels, {panelName: action.panelName});
      if (panelIndex !== -1) {
        return update(state, {
          openedLazyPanels: {
            [panelIndex]: {
              open: {
                $set: true,
              },
              panelProps: {
                $set: action.panelProps,
              },
              anchorEl: {
                $set: action.anchorEl,
              },
            },
          },
        });
      }
      return update(state, {
        openedLazyPanels: {
          $push: [
            {
              panelName: action.panelName,
              panelType: action.panelType,
              anchorEl: action.anchorEl,
              open: false,
              panelProps: action.panelProps,
            },
          ],
        },
      });

    case CLOSE_LAZY_PANEL:
      panelIndex = _.findIndex(state.openedLazyPanels, {panelName: action.panelName});
      if (panelIndex === -1) {
        return state;
      }
      return update(state, {
        openedLazyPanels: {
          [panelIndex]: {
            open: {
              $set: false,
            },
          },
        },
      });
    case SHOW_LAZY_PANEL:
      panelIndex = _.findIndex(state.openedLazyPanels, {panelName: action.panelName});

      return update(state, {
        openedLazyPanels: {
          [panelIndex]: {
            open: {
              $set: true,
            },
          },
        },
      });
    case UPDATE_LAZY_PANEL_PROPS:
      panelIndex = _.findIndex(state.openedLazyPanels, {panelName: action.panelName});

      return update(state, {
        openedLazyPanels: {
          [panelIndex]: {
            panelProps: {
              $merge: action.panelProps,
            },
          },
        },
      });
    case OPEN_STATIC_PANEL:
      if (_.find(state.openedStaticPanels, {panelName: action.panelName})) {
        return {
          ...state,
        };
      }

      return update(state, {
        openedStaticPanels: {
          $push: [
            {
              panelName: action.panelName,
              panelType: action.panelType,
              anchorEl: action.anchorEl,
            },
          ],
        },
      });
    case CLOSE_STATIC_PANEL:
      return {
        ...state,
        openedStaticPanels: _.reject(state.openedStaticPanels, {panelName: action.panelName}),
      };
    case TOGGLE_LEFT_MENU_SELECTED_ITEM: {
      return {
        ...state,
        leftMenuSelectedItem:
          state.leftMenuSelectedItem === action.leftMenuSelectedItem ? null : action.leftMenuSelectedItem,
      };
    }
    case ADD_DYNAMIC_ELEMENT:
      return update(state, {
        dynamicElements: {
          $apply: dynamicElements => {
            const dynamicElement = _.omit(action, ['type', 'closeOthers']);
            if (action.closeOthers) {
              dynamicElements = dynamicElements.map(dynamicElement =>
                update(dynamicElement, {props: {open: {$set: false}}})
              );
            }
            return dynamicElements
              ? dynamicElements.set(_.uniqueId(), dynamicElement)
              : Map([[_.uniqueId(), dynamicElement]]);
          },
        },
      });
    case CLOSE_DYNAMIC_ELEMENT:
      return update(state, {
        dynamicElements: {
          $apply: (dynamicElements: Map<any, any>) => {
            return dynamicElements.has(action.index)
              ? dynamicElements.update(action.index, dynamicElement =>
                  update(dynamicElement, {props: {open: {$set: false}}})
                )
              : dynamicElements;
          },
        },
      });
    case REMOVE_DYNAMIC_ELEMENT:
      return update(state, {
        dynamicElements: {
          $apply: (dynamicElements: Map<any, any>) => {
            return dynamicElements.delete(action.index);
          },
        },
      });
    case stageActions.CLEAR_STAGE_STATE:
    case stageActions.SET_SELECTED_ELEMENT_ID:
    case desktopElementActions.ADD_DESKTOP_ELEMENT:
      return {
        ...state,
        leftMenuSelectedItem: null,
      };
    default:
      return state;
  }
}

// The lazy panel mechanism  passes the closeLazyPanel function as a prop to the panel in a prop named onRequestClose
export function openLazyPanel(panelName, panelType, anchorEl = {}, panelProps = {}) {
  return {type: OPEN_LAZY_PANEL, panelName, panelType, anchorEl, panelProps};
}
export function closeLazyPanel(panelName) {
  return {type: CLOSE_LAZY_PANEL, panelName};
}
export function showLazyPanel(panelName) {
  return {type: SHOW_LAZY_PANEL, panelName};
}
export function updateLazyPanelProps(panelName, panelProps) {
  return {type: UPDATE_LAZY_PANEL_PROPS, panelName, panelProps};
}
export function openStaticPanel(panelName, panelType, anchorEl = {}) {
  return {type: OPEN_STATIC_PANEL, panelName, panelType, anchorEl};
}
export function closeStaticPanel(panelName) {
  return {type: CLOSE_STATIC_PANEL, panelName};
}
export const toggleLeftMenuSelectedItem = makeActionCreator(TOGGLE_LEFT_MENU_SELECTED_ITEM, 'leftMenuSelectedItem');

export function addDynamicDialog<P extends Pick<BasicDialogProps, 'open' | 'onExited' | 'onClose'>>(
  elementType: React.ComponentType<P>,
  props: Partial<P> = {},
  closeOthers: boolean = false
): any {
  props = {...props, open: true};
  if (props['anchorEl']) {
    props['anchorEl']['toJSON'] = _.constant('Some dom element');
  }
  elementType['toJSON'] = _.constant(elementType.displayName || 'UnknownComponent');
  return {type: ADD_DYNAMIC_ELEMENT, elementType, props, closeOthers};
}

export function closeDynamicElement(index: string) {
  return {type: CLOSE_DYNAMIC_ELEMENT, index};
}

export function removeDynamicElement(index: string) {
  return {type: REMOVE_DYNAMIC_ELEMENT, index};
}

export function addDynamicPopover<P extends PopoverProps>(
  elementType: React.ComponentType<P>,
  props: Partial<P> = {}
): any {
  props = {...props, open: true};
  if (props.anchorEl) {
    props.anchorEl['toJSON'] = _.constant('Some dom element');
  }
  elementType['toJSON'] = _.constant(elementType.displayName || 'UnknownComponent');
  return {type: ADD_DYNAMIC_ELEMENT, elementType, props};
}
